import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { users } from '../data/users';
import './LoginPage.css';
import logo from '../media/knowwinn_n.svg';

const LoginPage = ({ onLogin }) => {
  const [usuario, setUsuario] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const user = users.find(
      (u) => u.username === usuario && u.password === contrasena
    );

    if (user) {
      onLogin(user); // pasamos el objeto completo

      // Redirigir según rol
      switch (user.role) {
        case 'packaging':
          navigate('/');
          break;
        case 'marketing':
          navigate('/marketing');
          break;
        case 'admin':
          navigate('/admin');
          break;
        default:
          navigate('/');
      }
    } else {
      setError('Credenciales incorrectas');
    }
  };

  return (
    <div className="login-container">
      <div className="logo-container">
        <img src={logo} className="App-logo-login" alt="logo" />
      </div>
      <form onSubmit={handleSubmit}>
        <input
          className="login-input"
          type="text"
          placeholder="Usuario"
          value={usuario}
          onChange={(e) => setUsuario(e.target.value)}
          required
        />
        <input
          className="login-input"
          type="password"
          placeholder="Contraseña"
          value={contrasena}
          onChange={(e) => setContrasena(e.target.value)}
          required
        />
        <button className="login-button" type="submit">
          Entrar
        </button>
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </form>
    </div>
  );
};

export default LoginPage;
